module.exports = __webpack_public_path__ + "media/seo/no-0ce5b9af.jpg";